import type { AField } from '@/domain/field/AField';
import type { ImageField } from '@/domain/image/ImageField';

// Narrows instead of asserting. Every caller of this used to test `kind !== 'image'` and then
// cast, which is the shape the TypeScript rule names: prefer a type guard over `as`.
function isImageField(field: AField | undefined): field is ImageField {
    return field?.kind === 'image';
}

export { isImageField };
